import { render, staticRenderFns } from "./MyProject.vue?vue&type=template&id=b0d4f19e&"
import script from "./MyProject.vue?vue&type=script&lang=js&"
export * from "./MyProject.vue?vue&type=script&lang=js&"
import style1 from "./MyProject.vue?vue&type=style&index=1&id=b0d4f19e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports